import React, {useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import {
  Modal,
} from 'react-bootstrap'
import { StatesFilter } from "./states-filter/StatesFilter";
import { StatesTable } from "./states-table/StatesTable";
import { StatesGrouping } from "./states-grouping/StatesGrouping";
import { useStatesUIContext } from "./StatesUIContext";
import * as crud from "../../_redux/states/statesCrud";
import * as countryCrud from "../../_redux/countries/countriesCrud";

export function StatesCard() {
  const {user} = useSelector(state => state.auth);
  const userobject = user.userData;
  var superadmin = true;
  if (userobject.admin_role && userobject.admin_role !== 'superadmin' && userobject.is_admin) { superadmin = false; }
 
  const navigate = useNavigate();
  const location = useLocation();
  
  let tab = "all";
  const pathParts = location.pathname.split("/");
  if (pathParts[2] === "approved" || pathParts[2] === "pending" || pathParts[2] === "rejected") {
    tab = pathParts[2];
  }

  const callFilterFunction = (val) => {
    if(val==="all")       { navigate(`/state/`); }
    if(val==="approved")  { navigate(`/state/approved`); }
    if(val==="pending")   { navigate(`/state/pending`); }
    if(val==="rejected")  { navigate(`/state/rejected`); }
  };

  const statesUIContext = useStatesUIContext();
  const [showcreatemodal, showCreateModal] = useState(false);
  const [name,setName] = useState('')
  const [countryId, setCountryId] = useState('')
  const [isoCode, setIsoCode] = useState('')
  const [latitude, setLatitude] = useState('')
  const [longitude, setLongitude] = useState('')
  const [name_is_invalid,validateName] = useState('')
  const [country_is_invalid, validateCountry] = useState('')
  const [processing,setProcessing] = useState(false)
  const [countries, setCountries] = useState([])

  React.useEffect(() => {
    countryCrud.findCountries({ pageSize: 1000, pageNumber: 1, sortField: 'name', sortOrder: 'ASC' }).then(res => {
      if (res.data && res.data.entities) {
        setCountries(res.data.entities);
      }
    });
  }, []);

  const sampleFunction = async (event,val) => {
    event.stopPropagation()
    showCreateModal(val)
  };
  const delay = ms => new Promise(res => setTimeout(res, ms));

  const createState = async (event) => {
    let validations_ok = true
    validateName("")
    validateCountry("")
    if(name===""){
      validations_ok = false
      validateName("is-invalid");
    }
    if(countryId===""){
      validations_ok = false
      validateCountry("is-invalid");
    }

    if(validations_ok){
      setProcessing(true)
      await crud.createState({
        name,
        country_id: countryId,
        isoCode,
        latitude,
        longitude
      });
      await delay(1000);
      showCreateModal(false)
      setProcessing(false)
      
      // Reset form
      setName('')
      setCountryId('')
      setIsoCode('')
      setLatitude('')
      setLongitude('')
    }


  }
  const statesUIProps = useMemo(() => {
    return {
      ids: statesUIContext.ids,
      queryParams: statesUIContext.queryParams,
      setQueryParams: statesUIContext.setQueryParams,
      newStateButtonClick: statesUIContext.newStateButtonClick,
      openDeleteStatesDialog: statesUIContext.openDeleteStatesDialog,
      openEditStatePage: statesUIContext.openEditStatePage,
      openUpdateStatesStatusDialog:
        statesUIContext.openUpdateStatesStatusDialog,
      openFetchStatesDialog: statesUIContext.openFetchStatesDialog,
    };
  }, [statesUIContext]);
  return (
    
    <Card>
      <Modal centered show={showcreatemodal} onHide={() => showCreateModal(false)}>
          <Modal.Header >
              <Modal.Title>New State</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <div className="row">
                  <div className="col-md-12 form-group mt-3">
                    <select onChange={event => setCountryId(event.target.value)} value={countryId} className={`form-control ${country_is_invalid}`}>
                      <option value="">Select Country *</option>
                      {countries.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                    </select>
                    <div className="invalid-feedback">Country is required</div>
                  </div>
                  <div className="col-md-12 form-group mt-3">
                    <input onChange={event => setName(event.target.value)} value={name} className={`form-control ${name_is_invalid}`} type="text" placeholder="State Name *" />
                    <div className="invalid-feedback">Name is invalid</div>
                  </div>
                  <div className="col-md-12 form-group mt-3">
                    <input onChange={event => setIsoCode(event.target.value)} value={isoCode} className="form-control" type="text" placeholder="ISO Code (Optional)" />
                  </div>
                  <div className="col-md-6 form-group mt-3">
                    <input onChange={event => setLatitude(event.target.value)} value={latitude} className="form-control" type="text" placeholder="Latitude (Optional)" />
                  </div>
                  <div className="col-md-6 form-group mt-3">
                    <input onChange={event => setLongitude(event.target.value)} value={longitude} className="form-control" type="text" placeholder="Longitude (Optional)" />
                  </div>
              </div>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn btn-secondary" onClick={(event)=>sampleFunction(event,false)} >
              Close
            </button>
            <button type="button" className="btn btn-primary" onClick={()=>createState()} >
            { processing===true ? <i className="fas fa-circle-notch fa-spin"></i> : 'Save'}
            </button>
          </Modal.Footer>
      </Modal>
      <CardHeader title="State List">
        <CardHeaderToolbar>
        {
         (superadmin)? <button  type="button" className="btn btn-primary" onClick={(event)=>sampleFunction(event,true)} > New State </button>:<></>
        }
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <StatesFilter />
        {statesUIProps.ids.length > 0 && superadmin && (
          <>
            <StatesGrouping />
          </>
        )}

        <StatesTable />
      </CardBody>
    </Card>
  );
}
